import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Seo } from '../components/Seo';
import './GameContributionHub.css';

const GameSubmissionThanks = () => {
  const location = useLocation();
  return (
    <main className="submission-thanks-page">
      <Seo title="提交成功 | 怀旧游戏博物馆" description="游戏提交成功。" robots="noindex, nofollow" />
      <div className="submission-thanks-card">
        <span className="submission-thanks-mark">✓</span>
        <h1>感谢您的提交！</h1>
        <p>{location.state?.message || '您的游戏现已进入审核流程，通常会在 48 小时内完成审核。感谢您为怀旧游戏博物馆作出贡献！'}</p>
        <div className="submission-thanks-actions">
          <Link to="/contribute-games/recent">查看审核进度</Link>
          <Link to="/games">返回游戏库</Link>
        </div>
      </div>
    </main>
  );
};

export default GameSubmissionThanks;
